import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { t } from '../../../i18n/translate.js';
import '../../../components/Button/Button.js';
import '../../../components/AppLogo/AppLogo.js';
import '../../../components/Avatar/Avatar.js';
import '../../../components/Input/Input.js';
import '../../../components/Input/PasswordInput.js';
import '../../../components/Icon/Icon.js';
import '../../../components/Image/Image.js';
import '../../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../../components/Note/Note.js';
import '../../../components/RadioButton/RadioButton.js';
import '../../../components/RoundButton/RoundButton.js';
import '../../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../../components/Expandable/Expandable.js';
import '../../../components/PopOver/PopOver.js';
import '../../../components/Wizard/Wizard.js';
import '../../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../../components/ToggleButton/ToggleButton.js';
import ToggleButtonElement from '../../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../../components/Checkbox/Checkbox.js';
import SelectionField from '../../../components/SelectionField/SelectionField.js';
import '../../../components/Card/Card.js';
import '../../../components/Badge/Badge.js';
import '../../../components/SettingsItem/SettingsItem.js';
import '../../../components/SortableList/SortableList.js';
import '../../../components/Contacts/ContactItem.js';
import '../../../components/TopElement/TopElement.js';
import '../../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../../components/Flag/Flag.js';
import '../../../i18n/i18n.js';
import '../../../services/apiEndpoint/apiEndpoint.js';
import '../../../services/appConstants/appConstants.js';
import '../../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../../services/logout/rest-default-client/restDefaultClient.js';
import '../../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../../services/translation/translationUtils.module.scss.js';
import '../../../services/utilities/languageUtil.js';
import '../../../services/useContactUs/ContactUs.gql.js';
import '../../../services/storageHandler/StorageHandler.js';
import '../../../services/abortablePromise/AbortablePromise.js';
import '../../../services/abortablePoller/AbortablePoller.js';
import '../../../services/abortablePoller/ResumablePoller.js';
import '../../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './AlarmContact.module.scss.js';

function AlarmContact(_ref) {
  var user = _ref.user,
    onChangeIsOperatorContact = _ref.onChangeIsOperatorContact,
    onChangeUserHasKeys = _ref.onChangeUserHasKeys,
    onChangeRelation = _ref.onChangeRelation,
    className = _ref.className,
    AlarmContactHeader = _ref.AlarmContactHeader,
    showCodewordRemanider = _ref.showCodewordRemanider,
    _ref$relationTypes = _ref.relationTypes,
    relationTypes = _ref$relationTypes === void 0 ? [] : _ref$relationTypes;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    defaultValue = _useState2[0],
    setDefaultValue = _useState2[1];
  var callOrder = user.callOrder,
    relationWithInstallation = user.relationWithInstallation,
    keyHolder = user.keyHolder;
  var hasCallOrder = callOrder > 0;
  var handleRelationChange = function handleRelationChange(value) {
    var valueToSet = relationWithInstallation && !defaultValue ? relationWithInstallation : value;
    setDefaultValue(valueToSet);
    onChangeRelation(valueToSet);
  };
  var handleOperatorChange = function handleOperatorChange(newValToggle) {
    if (newValToggle) {
      showCodewordRemanider();
    }
    onChangeIsOperatorContact(newValToggle);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, AlarmContactHeader, /*#__PURE__*/React.createElement(ToggleButtonElement, {
    onClick: function onClick() {
      handleOperatorChange(!hasCallOrder);
    },
    isChecked: hasCallOrder,
    text: t('MPLIB_USERS_OPERATOR_CONTACT_TITLE'),
    dataTestId: "toggleButtonIsOperatorContact",
    subText: t('MPLIB_USERS_OPERATOR_CONTACT_DESCRIPTION'),
    className: classNames(styles.toggleButton, styles.borderBottom)
  }), hasCallOrder && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToggleButtonElement, {
    onClick: function onClick() {
      return onChangeUserHasKeys(!keyHolder);
    },
    isChecked: keyHolder,
    dataTestId: "toggleButtonHasKey",
    text: t('MPLIB_USERS_USER_HAS_KEYS_TITLE'),
    className: classNames(styles.toggleButton, styles.borderBottom)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.relation
  }, /*#__PURE__*/React.createElement("h2", {
    className: classNames('title', styles.title)
  }, t('MPLIB_USERS_INSTALLATION_RELATION_TITLE')), /*#__PURE__*/React.createElement(SelectionField, {
    defaultValue: defaultValue,
    name: "installation-relation",
    onChange: handleRelationChange,
    scrollIntoView: true
  }, relationTypes.filter(function (entry) {
    return entry.description;
  }).map(function (entry) {
    return /*#__PURE__*/React.createElement("p", {
      key: entry.relationName,
      value: entry.relationName
    }, entry.description);
  })))));
}
AlarmContact.propTypes = {
  user: PropTypes.shape({
    callOrder: PropTypes.number,
    keyHolder: PropTypes.bool,
    relationWithInstallation: PropTypes.string
  }),
  onChangeIsOperatorContact: PropTypes.func.isRequired,
  onChangeUserHasKeys: PropTypes.func.isRequired,
  onChangeRelation: PropTypes.func.isRequired,
  className: PropTypes.string,
  relationTypes: PropTypes.shape([]),
  AlarmContactHeader: PropTypes.node,
  showCodewordRemanider: PropTypes.func
};
AlarmContact.defaultProps = {
  user: {
    callOrder: 0,
    keyHolder: false,
    relationWithInstallation: null
  },
  className: '',
  relationTypes: [],
  AlarmContactHeader: null,
  showCodewordRemanider: function showCodewordRemanider() {
    return null;
  }
};

export { AlarmContact as default };
